import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import TasksCompletedSection from '../components/TasksCompletedSection';
import AgentsSection from '../components/AgentsSection';
import EcosystemSection from '../components/EcosystemSection';
import RevenueTestimonialSection from '../components/RevenueTestimonialSection';
import SolutionsSection from '../components/SolutionsSection';
import IntegrationsSection from '../components/IntegrationsSection';
import Footer from '../components/Footer';
import PricelessCtaSection from '../components/PricelessCtaSection';

const DentalLanding = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <TasksCompletedSection />
      <AgentsSection />
      <EcosystemSection />
      <RevenueTestimonialSection />
      <SolutionsSection />
      <IntegrationsSection />
      <PricelessCtaSection />
      <Footer />
    </div>
  );
};

export default DentalLanding;
